const actionFormType = {
  create: "create",
  edit: "edit",
  delete: "delete",
};

export default actionFormType;
